import { styled } from '@mui/material/styles';
import { Box, Toolbar, Paper, Button } from '@mui/material';

export const ToolbarPaper = styled(Paper)({
    width: '100%',
    boxShadow: '0px 4px 6px -2px rgba(0,0,0,0.2)',
    zIndex: 1300,
    position: 'relative',
});

export const ToolbarContainer = styled(Toolbar)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 16px',
});

export const LogoBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});

export const LogoImage = styled('img')({
    height: 80,
    marginRight: 8,
});

export const DarkBlueButton = styled(Button)(() => ({
    backgroundColor: '#002F87',
    color: '#fff',
    textTransform: 'uppercase',
    borderRadius: 4,
    padding: '6px 16px',
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: '#001B5E',
        boxShadow: 'none',
    },
}));

export const CartIconButton = styled('button')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: '#002F87',
    padding: '6px',
    marginLeft: 8,
    '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.08)',
        borderRadius: 4,
    },
});

export const Overlay = styled(Box)(() => ({
    position: 'fixed',
    inset: 0,
    zIndex: 1200,
    background: 'rgba(0,0,0,0.2)',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'stretch',
}));
